import { gql, TypedDocumentNode } from '@common/hooks';
import {
  PerformWorksShiftActionMutationCgResponse,
  PerformWorksShiftActionMutationVariables,
} from '@common/graphql/schema';

export const PerformWorksShiftAction: TypedDocumentNode<
  PerformWorksShiftActionMutationCgResponse,
  PerformWorksShiftActionMutationVariables
> = gql`
  mutation PerformWorksShiftAction(
    $worksShiftId: ID!
    $input: PerformWorksShiftActionInput!
  ) {
    performWorksShiftAction(worksShiftId: $worksShiftId, input: $input) {
      worksShift {
        id
        state
        organization {
          id
          vendorShiftBookingEnabled
        }
      }
      error
    }
  }
`;
